<template>
    <nav class="w-full bg-white shadow-lg z-[9999]">
      <div class="flex justify-between items-center px-4 py-4">
        <div class="flex items-center space-x-2">
          <img v-if="logoIcon" :src="logoIcon" alt="Logo" class="h-10" />
          <img v-if="logoWordmark" :src="logoWordmark" alt="Logo Text" class="h-8" />
        </div>
      </div>
    </nav>
  </template>
  
  <script>
  import { useStorageFile } from "@/composables/useStorageAssets";
  import { storageFiles } from "@/config/storageSections";

  export default {
    name: "OverlayBar",
    setup() {
      const { assetUrl: logoIcon } = useStorageFile(storageFiles.logoIcon);
      const { assetUrl: logoWordmark } = useStorageFile(storageFiles.logoWordmark);

      return {
        logoIcon,
        logoWordmark,
      };
    },
  };
  </script>
  
